import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { Slot } from "@radix-ui/react-slot";
import { forwardRef } from "react";

/**
 * @deprecated This interface is deprecated and will be removed in a future release.
 */
export interface BlockquoteProps extends React.HTMLAttributes<HTMLQuoteElement> {
  children?: React.ReactNode;

  /**
   * The quote style
   *
   * @default "default"
   */
  variant?: "default" | "norwegian";

  /**
   * Change the default rendered element for the one passed as a child, merging their props and behavior.
   *
   * @default false
   */
  asChild?: boolean;
}
/** @deprecated This component is deprecated and will be removed in a future release. */
export const Blockquote = forwardRef<HTMLQuoteElement, BlockquoteProps>(
  ({ children, asChild, className, variant, ...rest }, ref) => {
    const Component = asChild ? Slot : "blockquote";
    return (
      <Component
        ref={ref}
        className={clsx(
          "hds-blockquote",
          variant === "norwegian" && `hds-blockquote--norwegian`,
          className as undefined,
        )}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);
Blockquote.displayName = "Blockquote";
